
import { DocumentScannerOutlined } from '@mui/icons-material';
import PermContactCalendarOutlinedIcon from '@mui/icons-material/PermContactCalendarOutlined';
import TodayOutlinedIcon from '@mui/icons-material/TodayOutlined';
import { Alert, Container, Grid, Typography } from '@mui/material';
import Loading from 'components/loading';
import Localization from 'l18n/l18n';
import Appointments from 'models/appointments';
import * as React from 'react';
import { useParams } from 'react-router-dom';
import AttachedFilesList from '../../components/attached_files_list';
import AppointmentInformation from './components/appointment_information';
import PatientInformation from './components/patient_information';

const Appointment = () => {
    let { appointmentCalendarId } = useParams();
    const [appointmentData,setAppointmentData] = React.useState({}) ;
    const [isLoading,setIsLoading] = React.useState(true);
    const [error,setError] = React.useState(false);
    const [emptyAlert,setEmptyAlert] = React.useState(false);
    const getAppointmentData =async (appointmentCalendarId) =>{
        setIsLoading(true);
        setError(false);
        setEmptyAlert(false);
        if(isNaN(appointmentCalendarId)){
            setError('Invalid appointment') ;    
            return ;
        }
            await Appointments.getSingleAppointmentInformation(appointmentCalendarId).then(async result=>{
            
            setError(false);
            setAppointmentData(await result) ;
            if(!result.appointment_calendar_id || result.appointment_calendar_id==null){
              setEmptyAlert(true);
            }
    
            }).catch(error=>{
                setError(error);
            });

        setIsLoading(false);

    };

    React.useEffect(()=>{
    getAppointmentData(appointmentCalendarId);
    },[appointmentCalendarId]) ;

    if(isLoading){
        return <Loading isLoading={isLoading}/>;
    }

    if(error){
        return   <Alert severity="error">{Localization.translate['error']}</Alert> ;
    }
    if(emptyAlert){
        return   <Alert severity="warning">{Localization.translate['appointment_not_found']}</Alert> ;
    } 


     return (<Container maxWidth="lg" sx={{pt:'1rem',justifyContent:'center'}}>

    <Grid container alignItems="flex-start" spacing={4}>
        <Grid item container xs={12}>
            <Grid item xs={12} md={10} container gap={1} >
                <PermContactCalendarOutlinedIcon style={{color:'#279BFF'}}/>
                <Typography variant="h6">{Localization.translate['patient_information']} :</Typography>
            </Grid>
        </Grid>
        <Grid item container direction="column"  justifyContent="flex-start"    alignItems="center" xs={12}>
           {!isLoading && !error && <PatientInformation appointment_information={appointmentData} /> }
        </Grid>
                 <Grid item xs={12} md={10} container gap={1} >
                    <TodayOutlinedIcon style={{color:'#279BFF'}}/>
                    <Typography variant="h6" display={'flex'} gap={1}>
                    {Localization.translate['appointment_information']} :
                    </Typography>
                 </Grid>
        <Grid item container xs={12} rowGap={4}>
        {!isLoading && !error &&  <AppointmentInformation  appointment_information={appointmentData} />}
        </Grid>
        <Grid item container xs={12} justifyContent="center" rowGap={3}>
    {appointmentData.appointment_files.length > 0 && (


        <Grid item container  xs={12} columnGap={1}>
        <Grid container gap={1}>
            <DocumentScannerOutlined  style={{color:'#279BFF'}}/>  
            <Typography variant="h6">
            {Localization.translate['attached_files']} :
            </Typography>
        </Grid>
            <AttachedFilesList files={appointmentData.appointment_files} />
            </Grid>
            )}
        </Grid>
    </Grid>
    </Container>);

};

export default Appointment;